<template>
  <dropdown-module transitionName="fade" hideOnClick>
    <template v-slot:reference>
      <div class="cursor-pointer flex items-center text-sm">
        <span
          >{{ $t('Site language') }}: <span class="font-bold">{{ currentLang.name }}</span></span
        >
        <span class="icon-arrow_drop_down text-lg"></span>
      </div>
    </template>
    <ul class="languages">
      <li
        v-for="item in getCountries"
        :key="item.code"
        @click="changeLang(item)"
        class="border-b-1 border-grey last:border-b-0 cursor-pointer px-8 py-4 text-center flex items-center bg-white"
      >
        <img class="w-5 mr-3" :src="require(`@/locales/icons/${item.code}.svg`)" :alt="item.code" />
        <p class="text-grey-darkest text-xs leading-normal">{{ item.name }}</p>
        <span v-if="currentLang.code === item.code" class="icon-checkmark text-green text-3xs ml-auto"></span>
      </li>
    </ul>
  </dropdown-module>
</template>

<script>
import DropdownModule from '@/components/shared/DropdownModule'
import localStorageService from '@/core/localstorage.service'
import formatterService from '@/core/format.service'

import locales from '@/locales/locales'
import { useCompanyStore } from '@/stores/company'

export default {
  name: 'LanguagesDropdown',
  components: { DropdownModule },

  setup () {
    const companyStore = useCompanyStore()

    return {
      companyStore
    }
  },

  computed: {
    baseRouteConfig () {
      return this.companyStore.baseRouteConfig
    },
    getCountries () {
      return this.$i18n.availableLocales.map(item => locales[item])
    },
    currentLang () {
      return locales[this.$i18n.locale]
    }
  },

  methods: {
    changeLang (value) {
      formatterService.updateFormatLocale(value.code)
      this.$i18n.locale = value.code
      this.$router.replace({
        ...this.baseRouteConfig,
        name: this.$route.name,
        params: { language: value.code }
      })
      localStorageService.setItem('locale', value.code)
    }
  }
}
</script>

<style scoped>
.languages {
  min-width: 200px;
}
</style>
